import { render } from "./UserWellnessChart.vue?vue&type=template&id=1c54fc72&scoped=true"
import script from "./UserWellnessChart.vue?vue&type=script&lang=js"
export * from "./UserWellnessChart.vue?vue&type=script&lang=js"

import "./UserWellnessChart.vue?vue&type=style&index=0&id=1c54fc72&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c54fc72"]])

export default __exports__